import  React from "react";
import { Route, Routes } from "react-router";
import { Link, useNavigate } from "react-router-dom";
// MUI
import { styled } from "@mui/material/styles";
import { Button,Box, Drawer, CssBaseline, Toolbar, List, ListItem, ListItemText, ListItemIcon, Typography, IconButton, Menu, MenuItem} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { useState } from "react";

//page

import WoodPage from "../screens/WoodPage";
import AnnPage from "../screens/AnnPage";
import RichTextPage from "../screens/RichTextPage";
import Dashboard from "../screens/Dashboard";
import AnnounceCreate from "./AnnounceCreate";
// ICON
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ForestIcon from '@mui/icons-material/Forest';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import WoodCreate from "./WoodCreate";
import RichTextCreate from "./RichTextCreate";
import RichTextUpdate from "./RichTextUpdate";
import AnnounceUpdate from "./AnnounceUpdate";
import WoodUpdate from "./WoodUpdate";
import Footer from "./Footer";
import {AuthProvider, useAuth} from '../contexts/AuthContext'
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import ForgotPassword from "./ForgotPassword";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// Drawer size
const drawerWidth = 250;


  

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen
      }),
      marginLeft: 0
    })
  })
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open"
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",

}));

export default function App() {

  
  const status = true;
  const [error, setError] = useState("")
  const { currentUser, logout } = useAuth()
  const Navigate = useNavigate()
  const [open, setOpen] = React.useState(false);
  
  async function handleLogout() {
    setError("")

    try {
      console.log(currentUser)
      await logout()
      // history.push("/login")
      setOpen(false)
      Navigate('/login')
    } catch (e) {
      // console.log(e)
      setError("Failed to log out")
    }
  }


  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar sx={{backgroundColor:"#C69B7B"}}>
          {currentUser ? 
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{ mr: 2, ...(open && { display: "none" }) }}
          >
            <MenuIcon />
          </IconButton> : <></>}
          <Link to ='/'onClick={() => {setOpen(false)}}> 
          <img src="https://i.imgur.com/5g5Xbb3.png"  width={"10%"} />
          </Link>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            
          </Typography>
          {currentUser  ? <Button variant="link" onClick={handleLogout} >Log Out</Button> : <></>}

        </Toolbar>
      </AppBar>

      <Drawer

        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
          
        }}
        variant="persistent"
        anchor="left"
        open={open}
        PaperProps={{sx: {
          backgroundColor:"#FCFCFC"
        }}}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </DrawerHeader>

        <List>
          <Link to="/" style={{textDecoration: 'none', color:'#939393'}}>
            <ListItem button key="แดชบอร์ด">
            <ListItemIcon>
                <DashboardIcon/>
              </ListItemIcon>
              <ListItemText primary={<Typography style={{ fontFamily:'Prompt'}}>แดชบอร์ด</Typography>} />
            </ListItem>
          </Link>
          <Link to="/wood" style={{textDecoration: 'none', color:'#939393'}}>
            <ListItem button key="จัดการข้อมูลไม้">
            <ListItemIcon>
                <ForestIcon/>
              </ListItemIcon>
              <ListItemText primary={<Typography style={{ fontFamily:'Prompt'}}>จัดการข้อมูลไม้</Typography>} />
            </ListItem>
          </Link>

          <Link to="/announce" style={{textDecoration: 'none', color:'#939393'}}>
            <ListItem button key="จัดการประกาศ">
            <ListItemIcon>
                <AnnouncementIcon/>
              </ListItemIcon>
              <ListItemText primary={<Typography style={{ fontFamily:'Prompt'}}>จัดการประกาศ</Typography>}/>
            </ListItem>
          </Link>

          <Link to="/content" style={{textDecoration: 'none', color:'#939393'}}>
            <ListItem button key="จัดการคู่มือ">
              <ListItemIcon>
                <HelpCenterIcon/>
              </ListItemIcon>
              <ListItemText disableTypography
              primary={<Typography style={{ fontFamily:'Prompt'}}>จัดการคู่มือ</Typography>} />
              
            </ListItem>
          </Link>
        </List>
      </Drawer>

      <Main open={open}>
        <DrawerHeader />

        <AuthProvider>
          <Routes>
          <Route path='/' element={<PrivateRoute><Dashboard/></PrivateRoute>} />
          <Route path="/wood" element={<PrivateRoute><WoodPage /></PrivateRoute>} />
          <Route path="/announce" element={<PrivateRoute><AnnPage /></PrivateRoute>} />
          <Route path="/content" element={<PrivateRoute><RichTextPage/></PrivateRoute>}/>
          <Route path='/wood/create' element={<PrivateRoute><WoodCreate/></PrivateRoute>}/>
          <Route path='/content/create' element={<PrivateRoute><RichTextCreate/></PrivateRoute>}/>
          <Route path='/announce/create' element={<PrivateRoute><AnnounceCreate/></PrivateRoute>}/>
          <Route path='/content/update/:id' element={<PrivateRoute>< RichTextUpdate/></PrivateRoute>}/>
          <Route path='/announce/update/:id' element={<PrivateRoute>< AnnounceUpdate/></PrivateRoute>}/>
          <Route path='/wood/update/:id' element={<PrivateRoute>< WoodUpdate/></PrivateRoute>}/>
          <Route path='/login' element={<Login/>}/>
          <Route path="/forgot-password" element={<ForgotPassword/>} />

        </Routes> 
      </AuthProvider>


      <Footer/>
      </Main>

    </Box>
    
  
    </div>
  );
}

